import { render, staticRenderFns } from "./economy-budget.vue?vue&type=template&id=fba4e092&scoped=true"
import script from "./economy-budget.vue?vue&type=script&lang=js"
export * from "./economy-budget.vue?vue&type=script&lang=js"
import style0 from "./economy-budget.vue?vue&type=style&index=0&id=fba4e092&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba4e092",
  null
  
)

export default component.exports